import { render, staticRenderFns } from "./purchaseOrderReturnDetail.vue?vue&type=template&id=35bff282&scoped=true"
import script from "./purchaseOrderReturnDetail.vue?vue&type=script&lang=ts"
export * from "./purchaseOrderReturnDetail.vue?vue&type=script&lang=ts"
import style0 from "./purchaseOrderReturnDetail.vue?vue&type=style&index=0&id=35bff282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bff282",
  null
  
)

export default component.exports